import React, { Component, Fragment } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import SimpleMap from '../components/SimpleMap';
import StepHeader from '../../common/StepHeader';
import axios from 'components/AppRequest';
import {
  setReturnAddressPhrase, setReturnAddressObject,
  setDepartureAddressPhrase, setDepartureAddressObject,
  setDifferentReturnAddress, setDepartureAddressPostcodeErrorLatLng,
  setReturnAddressPostcodeErrorLatLng,
  startLoadingDataOnMap, stopLoadingDataOnMap
} from 'components/actions/bookingActions';

import { RETURN, DEPARTURE }
  from 'components/components/booking/utils/FlightConstants';
import { connect } from 'react-redux';
import AddressComponent from './components/AddressComponent';
import SummaryBooking from './components/SummaryBooking';
import AddressHelper from './utils/AddressHelper';
import BookingRedirect from '../utils/BookingRedirect';
import CommunicateBox from 'components/components/common/CommunicateBox';
import { jumpingMarkerData } from 'components/common/helpers/jumpingMarkerDataHelper';
import merge from 'lodash/merge';
import classNames from 'classnames';
import {
  fetchPriceList,
  fetchCustomerAddresses,
  fetchBusStops,
  fetchCities,
  createErrorNotification
} from 'components/actions/serviceActions';
import T from 'components/common/translations/Translate';
import TransHelper from 'components/common/translations/TransHelper';

// https://developers.google.com/maps/documentation/javascript/reference/places-autocomplete-service#AutocompletionRequest
// MAP service

class MapSearch extends Component {

  constructor(props, context) {
    super(props, context);
    var defaultMarkerDeparture = props.departureAddress.selectedObject ?
      props.departureAddress.selectedObject :
      null;
    var defaultMarkerReturn = props.returnAddress.selectedObject ?
      props.returnAddress.selectedObject :
      null;
    this.state = {
      buttonFavouriteFirstAddress: false,
      buttonFavouriteSecondAddress: false,
      hideErrorBeforeFirstChooseReturnAddress: true,
      addressDepartureMarker: defaultMarkerDeparture,
      addressReturnMarker: defaultMarkerReturn,
      showDepartureFavouriteList: false,
      showReturnFavouriteList: false,
    };
  }

  trans = (key) => {
    return TransHelper.translate(this.props.locale, 'content.bookingStep3.map.' + key);
  }

  componentDidMount() {
    new BookingRedirect(this.props).canViewMap();
    this.props.fetchPriceList();
    this.props.fetchBusStops();
    this.props.fetchCities();
    this.props.fetchCustomerAddresses();
  }

  handleAddDiferentReturnAddress = (e) => {
    e.preventDefault();
    var value = !this.props.differentReturnAddress;
    if (value === false) {
      this.props.setReturnAddressObject(null);
      this.props.setReturnAddressPhrase('');
      this.props.setReturnAddressPostcodeErrorLatLng(null, null, null, null);
    }
    this.props.setDifferentReturnAddress(value);
  }

  _handleRemoveDifferentAddress = (e) => {
    this.props.setReturnAddressPostcodeErrorLatLng(null, null, null, null);
    this.props.setReturnAddressObject(null);
    this.props.setReturnAddressPhrase('');
    this.props.setDifferentReturnAddress(null);
    this.setState({ addressReturnMarker: null });
  }

  onDeparturePhraseChange = (event) => {
    this.props.setDepartureAddressPhrase(event.target.value);
  }

  onDepartureItemChoose = (item) => {
    this.props.setDepartureAddressPostcodeErrorLatLng(null, null, null, null);
    this.props.setDepartureAddressObject(null);
    this.props.setDepartureAddressObject(item);
    this.props.setDepartureAddressPhrase(item.label);
    this.setState({ addressDepartureMarker: item });
  }

  onReturnPhraseChange = (event) => {
    this.props.setReturnAddressPhrase(event.target.value);
  }

  onReturnItemChoose = (item) => {
    this.props.setReturnAddressPostcodeErrorLatLng(null, null, null, null);
    this.props.setReturnAddressObject(null);
    this.props.setReturnAddressObject(item);
    this.props.setReturnAddressPhrase(item.label);
    this.setState({
      addressReturnMarker: item,
      hideErrorBeforeFirstChooseReturnAddress: false
    });
  }

  jumpingMarkersData = () => {
    const { addressDepartureMarker, addressReturnMarker } = this.state;
    return [
      jumpingMarkerData(
        addressDepartureMarker,
        this.props.busStops,
        DEPARTURE
      ),
      jumpingMarkerData(
        addressReturnMarker,
        this.props.busStops,
        RETURN
      ),
    ]
  }

  setDeparturePlaceData = (error, postcode, street, latLng) => {
    var data = merge({}, this.state.addressDepartureMarker);
    data.lat = latLng['lat'];
    data.lng = latLng['lng'];
    this.props.setDepartureAddressPostcodeErrorLatLng(error, postcode, street, latLng);
    this.setState({ addressDepartureMarker: data }, () => {
      var helper = new AddressHelper(this.props);
      if (helper.getDepartureError()) {
        this.props.createErrorNotification({
          title: 'Error',
          message: helper.getDepartureError()
        })
      }
    });
  }

  setReturnPlaceData = (error, postcode, street, latLng) => {
    var data = merge({}, this.state.addressReturnMarker);
    data.lat = latLng['lat'];
    data.lng = latLng['lng'];
    this.props.setReturnAddressPostcodeErrorLatLng(error, postcode, street, latLng);
    this.setState({ addressReturnMarker: data }, () => {
      var helper = new AddressHelper(this.props);
      if (helper.getReturnError()) {
        this.props.createErrorNotification({
          title: 'Error',
          message: helper.getReturnError()
        })
      }
    });
  }

  handleShowDepartureFavouriteList = (value) => {
    if (value === true || value === false) {
      this.setState({ showDepartureFavouriteList: value });
    } else {
      this.setState({
        showDepartureFavouriteList: !this.state.showDepartureFavouriteList,
        showReturnFavouriteList: false
      });
    }
  }

  handleShowReturnFavouriteList = (value) => {
    if (value === true || value === false) {
      this.setState({ showReturnFavouriteList: value });
    } else {
      this.setState({
        showReturnFavouriteList: !this.state.showReturnFavouriteList,
        showDepartureFavouriteList: false
      });
    }
  }

  render() {
    var addressHelper = new AddressHelper(this.props);
    const { childrenNumber } = this.props;

    return (
      <Fragment>
        <div className="content content--map-hidden" style={{ padding: '0!important' }}>
          <div className="map-full">
            <div className="content__desc">
              <StepHeader
                link="routes.url.flights"
                linkTitle={this.trans('backToSelectFlight')}
                step={childrenNumber === 0 ? 2 : 3}
                maxSteps={5}
                title=""
                margin={20}
                booking
              />

              <form>
                <fieldset>
                  <legend className="visuallyhidden">Select Place</legend>
                  <div className="map safari_only">
                    <div className={classNames(
                      'map__address', {
                        'map__address--return': this.props.differentReturnAddress
                      }
                    )}>
                      <div className="first-address">
                        <AddressComponent
                          addressData={this.props.departureAddress}
                          busStops={this.props.busStops}
                          customerAddresses={this.props.customerAddresses}
                          handleShowFavouriteList={this.handleShowDepartureFavouriteList}
                          isBooking
                          isLogged={this.props.isLogged}
                          isValid={addressHelper.getDepartureError() === null}
                          loadingDataOnMap={this.props.loadingDataOnMap}
                          onItemChoose={this.onDepartureItemChoose}
                          onPhraseChange={this.onDeparturePhraseChange}
                          setAddressPostcodeErrorLatLng={this.setDeparturePlaceData}
                          showFavouriteList={this.state.showDepartureFavouriteList}
                          startLoadingDataOnMap={this.props.startLoadingDataOnMap}
                          stopLoadingDataOnMap={this.props.stopLoadingDataOnMap}
                        />
                      </div>

                      <div className={classNames(
                        'second-address',
                        'different-address', {
                          'different-address--return': this.props.differentReturnAddress
                        }
                      )}>
                        {
                          // this.props.returnFlight &&
                          // <button
                          //   onClick={this.handleAddDiferentReturnAddress}
                          //   className="addReturnAdress">
                          //   <FontAwesomeIcon icon={['fas', 'plus-circle']} />
                          //   {this.trans('addAddress.first')} <span>{this.trans('addAddress.second')}</span>{this.trans('addAddress.third')}
                          // </button>
                        }
                        {
                          this.props.differentReturnAddress &&
                          <Fragment>
                            <AddressComponent
                              addressData={this.props.returnAddress}
                              busStops={this.props.busStops}
                              customerAddresses={this.props.customerAddresses}
                              handleShowFavouriteList={this.handleShowReturnFavouriteList}
                              isBooking
                              isLogged={this.props.isLogged}
                              isValid={addressHelper.getReturnError() === null}
                              loadingDataOnMap={this.props.loadingDataOnMap}
                              onItemChoose={this.onReturnItemChoose}
                              onPhraseChange={this.onReturnPhraseChange}
                              setAddressPostcodeErrorLatLng={this.setReturnPlaceData}
                              showFavouriteList={this.state.showReturnFavouriteList}
                              startLoadingDataOnMap={this.props.startLoadingDataOnMap}
                              stopLoadingDataOnMap={this.props.stopLoadingDataOnMap}
                            />
                            {/* <button
                              className="button--close-round"
                              title={this.trans('removeReturnAddress')}
                              onClick={this._handleRemoveDifferentAddress}
                            >
                              <span className="visuallyhidden">close</span>
                            </button> */}
                          </Fragment>
                        }
                      </div>
                    </div>

                    <SummaryBooking {...this.props} />

                    {/* place for api map */}
                    <div className="map__api">
                      <SimpleMap
                        isBooking
                        jumpingMarkers={this.jumpingMarkersData()}
                        markers={[{
                          lat: 59.183045,
                          lng: 10.256580,
                          icon: 'plane',
                          label: 'Torp',
                        }]}
                      />
                    </div>
                  </div>
                </fieldset>
              </form>
            </div>

          </div>

        </div>
      </Fragment>

    );
  }
}

const mapStateToProps = (state) => {
  return {
    airportFrom: state.booking.airportFrom,
    airportTo: state.booking.airportTo,
    adultsNumber: state.booking.adultsNumber,
    busStops: state.service.busStops,
    customerAddresses: state.service.customerAddresses,
    childrenNumber: state.booking.childrenNumber,
    departureFlight: state.booking.departureFlight,
    returnFlight: state.booking.returnFlight,
    returnAddress: state.booking.returnAddress,
    departureAddress: state.booking.departureAddress,
    differentReturnAddress: state.booking.differentReturnAddress,
    departurePrice: state.booking.departurePrice,
    returnPrice: state.booking.returnPrice,
    isLogged: state.app.isLogged,
    loadingDataOnMap: state.booking.loadingDataOnMap,
    addressChanged: state.booking.addressChanged,
    priceList: state.service.priceList,
  };
};

const mapDispatchToProps = {
  setReturnAddressPhrase,
  setReturnAddressObject,
  setDepartureAddressPhrase,
  setDepartureAddressObject,
  setDifferentReturnAddress,
  setDepartureAddressPostcodeErrorLatLng,
  setReturnAddressPostcodeErrorLatLng,
  startLoadingDataOnMap,
  stopLoadingDataOnMap,
  fetchPriceList,
  fetchCustomerAddresses,
  fetchBusStops,
  fetchCities,
  createErrorNotification
};

export default connect(mapStateToProps, mapDispatchToProps)(MapSearch);
